// extracted by mini-css-extract-plugin
export default {"leftIcon":"ModuleItemContainer_leftIcon__4ye91","menuItem":"ModuleItemContainer_menuItem__GcRvo"};